var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 16,
    viewBox: "0 0 12.8 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "profile",
    d: "M4.708,10.214a20.211,20.211,0,0,1,3.454,0,11.945,11.945,0,0,1,1.867.275,3.328,3.328,0,0,1,2.559,1.57,2.4,2.4,0,0,1-.021,2.02A3.384,3.384,0,0,1,9.98,15.655a11.967,11.967,0,0,1-1.86.267A15.586,15.586,0,0,1,6.295,16H6.078a.613.613,0,0,1,0-1.218h.478c.479-.006.962-.028,1.444-.07a11.387,11.387,0,0,0,1.692-.239c.958-.211,1.559-.514,1.748-.915a1.126,1.126,0,0,0,0-.971c-.189-.408-.79-.725-1.727-.915a10.888,10.888,0,0,0-1.72-.246,17.912,17.912,0,0,0-3.251,0,11.478,11.478,0,0,0-1.7.239c-.958.211-1.552.514-1.748.915a1.168,1.168,0,0,0-.1.486,1.2,1.2,0,0,0,.1.493,2.032,2.032,0,0,0,1.4.824h0l.081.022a.612.612,0,0,1-.389,1.161A3.1,3.1,0,0,1,.226,14.085a2.373,2.373,0,0,1,0-2.02A3.33,3.33,0,0,1,2.8,10.481,12.828,12.828,0,0,1,4.708,10.214ZM4.772.326a4.237,4.237,0,0,1,4.641.932,4.308,4.308,0,0,1,.919,4.674,4.254,4.254,0,0,1-8.19-1.645h0l0-.185A4.286,4.286,0,0,1,4.772.326Zm1.621.9a3.031,3.031,0,0,0-2.155.894,3.083,3.083,0,0,0,.984,5.008,3.034,3.034,0,0,0,3.325-.661A3.084,3.084,0,0,0,9.21,3.121,3.048,3.048,0,0,0,6.393,1.225Z",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.846c4f9dfd961dc3611daa1660d8bac8.svg";
export { ForwardRef as ReactComponent };